module.exports = "../dist/frontend/icons/ui/yes.svg?04fac85f1f20034de03e8f7d75849109";